// 包含中文（汉字）
export const includeChinese = /.*[\u4e00-\u9fa5]+.*$/;

// 复杂密码：大小写字母+数字+英文
export const complexPasswordPattern = /^(?![A-z0-9]+$)(?=.[^%&',;=?$\x22])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,20}$/;

// 手机号
export const phoneReg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\d{8}$/;

// 固话加手机号码(8-12位纯数字)
export const telOrPhoneNoReg = /^[0-9]\d{7,11}$/;
